/** Used to map Latin Unicode letters to basic Latin letters. */
export const deburredLetters = {
    '\u010a': 'C',
    '\u010b': 'c',
    '\u010c': 'C',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u010f': 'd',
    '\u011a': 'E',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011d': 'g',
    '\u011e': 'G',
    '\u011f': 'g',
    '\u012a': 'I',
    '\u012b': 'i',
    '\u012c': 'I',
    '\u012d': 'i',
    '\u012e': 'I',
    '\u012f': 'i',
    '\u013a': 'l',
    '\u013b': 'L',
    '\u013c': 'l',
    '\u013d': 'L',
    '\u013e': 'l',
    '\u013f': 'L',
    '\u014a': 'N',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014d': 'o',
    '\u014e': 'O',
    '\u014f': 'o',
    '\u015a': 'S',
    '\u015b': 's',
    '\u015c': 'S',
    '\u015d': 's',
    '\u015e': 'S',
    '\u015f': 's',
    '\u016a': 'U',
    '\u016b': 'u',
    '\u016c': 'U',
    '\u016d': 'u',
    '\u016e': 'U',
    '\u016f': 'u',
    '\u017a': 'z',
    '\u017b': 'Z',
    '\u017c': 'z',
    '\u017d': 'Z',
    '\u017e': 'z',
    '\u017f': 's',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0101': 'a',
    '\u0102': 'A',
    '\u0103': 'a',
    '\u0104': 'A',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0107': 'c',
    '\u0108': 'C',
    '\u0109': 'c',
    '\u0110': 'D',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0113': 'e',
    '\u0114': 'E',
    '\u0115': 'e',
    '\u0116': 'E',
    '\u0117': 'e',
    '\u0118': 'E',
    '\u0119': 'e',
    '\u0120': 'G',
    '\u0121': 'g',
    '\u0122': 'G',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0125': 'h',
    '\u0126': 'H',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u0129': 'i',
    '\u0130': 'I',
    '\u0131': 'i',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u0140': 'l',
    '\u0141': 'L',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0144': 'n',
    '\u0145': 'N',
    '\u0146': 'n',
    '\u0147': 'N',
    '\u0148': 'n',
    '\u0149': "'n",
    '\u0150': 'O',
    '\u0151': 'o',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0154': 'R',
    '\u0155': 'r',
    '\u0156': 'R',
    '\u0157': 'r',
    '\u0158': 'R',
    '\u0159': 'r',
    '\u0160': 'S',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0163': 't',
    '\u0164': 'T',
    '\u0165': 't',
    '\u0166': 'T',
    '\u0167': 't',
    '\u0168': 'U',
    '\u0169': 'u',
    '\u0170': 'U',
    '\u0171': 'u',
    '\u0172': 'U',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xc6': 'Ae',
    '\xc7': 'C',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xd0': 'D',
    '\xd1': 'N',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xdd': 'Y',
    '\xde': 'Th',
    '\xdf': 'ss',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xe6': 'ae',
    '\xe7': 'c',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xf0': 'd',
    '\xf1': 'n',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xfd': 'y',
    '\xfe': 'th',
    '\xff': 'y',
};
